<template>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
    <template v-slot:info="{record}">
      <a-card-meta>
        <template #avatar>
          <img :src="info.picdomain+'/'+(record.product_image||record.cover_image_url)" alt=""
            style="width:50px;height: 50px;object-fit:cover">
        </template>
        <template #description>{{record.product_name}}</template>
      </a-card-meta>
    </template>
    <template v-slot:action="{ record }">
      <a-button type="primary" @click='select(record)' :ghost="!record.select" v-if='!checkout'>{{!record.select ?
        "选择":"已选择"}}</a-button>
      <a-button type="primary" @click='checkBnt(record)' :ghost="!record.select" v-else>{{!record.select ? "选择":"已选择"}}
      </a-button>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
  <div class="s_flex_center m-t-25" v-if='checkout'>
    <a-button type="primary" @click='confirm'>确定</a-button>
  </div>
</template>
<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
import{priceTem} from '@/api/online'
  import { iscode } from "@/utils/app";
  import store from "@/store";
  // 初始化默认筛选项数值
  let defSearch = {
    product_name: "",
    page: 1,
    limit: 5,
    status: 1
  };
  export default {
    name: "selectDiscountTemplate",
    components: {},
    props: {
      selectList: {
        type: Array
      },
      checkout: {
        type: Boolean
      },
      selectLimit:{
        type:Number
      }
    },
    setup(props, { emit }) {
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        info: store.state.user.info,
        listLoading: false,
        total: 1,
        selectList: [],
        checkout: false,
      });
      let columns = [
      {
        title: "模板名称",
        dataIndex: "tem_name",
        key: "tem_name",
      },
      {
        title: "折扣率",
        dataIndex: "discount_rate",
        key: "discount_rate",
      },
      {
        title: "备注",
        dataIndex: "remark",
        key: "remark",
      },
      {
        title: "创建时间",
        dataIndex: "created_at",
        key: "created_at",
      },
      {
        title: "操作",
        key: "action",
        width: 120,
        slots: { customRender: "action" },
      },
    ];
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      const _lodash = inject("_lodash");

      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      //单选
      const select = (e) => {
        data.value.map(item => item.select = false)
        e.select = !e.select
        emit("select", e);
      }
      //多选
      const checkBnt = (e) => {
        if(props.selectLimit && state.selectList.length == 5 && !e.select){
          message.error('最多只能选择'+props.selectLimit+'个商品');
          return
        }
        if(!e.select){
          state.selectList.push(e)
        }else{
          // state.selectList
          var key=-1
          state.selectList.forEach((v,k)=>{
            if(v.id==e.id){
              key=k
            }
          })
          if(key!=-1){
            state.selectList.splice(key,1)
          }
        }
        e.select = !e.select
      }
      //多选确认
      const confirm = () => {
        emit("select", state.selectList);
      }
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await priceTem(values).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data;
            state.total = res.meta.total;
            if (state.selectList.length > 0) {
              data.value.forEach(i => {
                if (state.selectList.find(v => i.id == v.id)) {
                  i.select = true
                }else{
                  i.select = false
                }
              })
            }
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };
      onMounted(() => {
        if(props.selectList){
          state.selectList = JSON.parse(JSON.stringify(props.selectList))
        }
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        select,
        checkBnt,
        confirm
      };
    },
  };
</script>